import React from "react";
import styled from "styled-components";
import { Bio } from "../../data/constants";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
// import GitLabIcon from "@mui/icons-material/GitLab";
import GitHubIcon from "@mui/icons-material/GitHub";

const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const FooterWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.div`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
`;

const Nav = styled.nav`
  width: 100%;
  max-width: 800px;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1.2rem;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;
const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const Copyright = styled.p`
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo>Saad Al-Abyad</Logo>
        <Nav>
          <NavLink href="#About">About</NavLink>
          <NavLink href="#Skills">Skills</NavLink>
          <NavLink href="#Experience">Experience</NavLink>
          <NavLink href="#Projects">Projects</NavLink>
          <NavLink href="#Education">Education</NavLink>
        </Nav>
        <SocialMediaIcons>
          {Bio.facebook && (
            <SocialMediaIcon href={Bio.facebook} target="_blank">
              <FacebookIcon />
            </SocialMediaIcon>
          )}
          {Bio.twitter && (
            <SocialMediaIcon href={Bio.twitter} target="_blank">
              <TwitterIcon />
            </SocialMediaIcon>
          )}
          {Bio.linkedin && (
            <SocialMediaIcon href={Bio.linkedin} target="_blank">
              <LinkedInIcon />
            </SocialMediaIcon>
          )}
          {Bio.instagram && (
            <SocialMediaIcon href={Bio.instagram} target="_blank">
              <InstagramIcon />
            </SocialMediaIcon>
          )}
          {Bio.github && (
            <SocialMediaIcon href={Bio.github} target="_blank">
              <GitHubIcon />
            </SocialMediaIcon>
          )}
          {Bio.whatsapp && (
            <SocialMediaIcon
              href={`https://wa.me/${Bio.whatsapp}`}
              target="_blank"
            >
              <i className="fab fa-whatsapp"></i>
            </SocialMediaIcon>
          )}
          {Bio.telegram && (
            <SocialMediaIcon
              href={`https://t.me/${Bio.telegram}`}
              target="_blank"
            >
              <i className="fab fa-telegram-plane"></i>
            </SocialMediaIcon>
          )}
        </SocialMediaIcons>

        <Copyright>&copy; 2025 Saad Al-Abyad. All rights reserved.</Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
